var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkoCoreLogotype2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 60,
    viewBox: "0 0 197 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "OKO_Core_Logotype2",
    d: "M162.641 42.9128C154.378 42.9128 147.672 37.1034 147.672 30.0002C147.672 22.8969 154.378 17.0875 162.641 17.0875C170.905 17.0875 177.611 22.8969 177.611 30.0002C177.611 37.1034 170.878 42.9128 162.641 42.9128ZM162.641 0.161133C143.897 0.161133 128.716 13.5227 128.716 30.0002C128.716 46.4776 143.923 59.8392 162.641 59.8392C181.386 59.8392 196.566 46.4776 196.566 30.0002C196.566 13.5227 181.386 0.161133 162.641 0.161133ZM34.5179 42.9128C26.2544 42.9128 19.5486 37.1034 19.5486 30.0002C19.5486 22.8969 26.2544 17.0875 34.5179 17.0875C42.7814 17.0875 49.4872 22.8969 49.4872 30.0002C49.4872 37.1034 42.755 42.9128 34.5179 42.9128ZM34.4915 0.161133C15.7733 0.161133 0.566406 13.5227 0.566406 30.0002C0.566406 46.4776 15.7733 59.8392 34.4915 59.8392C53.2097 59.8392 68.4166 46.4776 68.4166 30.0002C68.443 13.5227 53.2361 0.161133 34.4915 0.161133ZM111.212 30.0002L137.877 0.979726H114.169L91.6494 25.3791V1.00613H72.2447V59.0206H91.6494V34.6741L114.064 59.047H137.877L111.08 30.0002H111.212Z",
    fill: "#002E19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkoCoreLogotype2);
export default __webpack_public_path__ + "static/media/OKO_Core_Logotype2.29b8cf9b7d8071a03235c4eadf91000a.svg";
export { ForwardRef as ReactComponent };